
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 2c1.645 0 3 1.355 3 3v4.188A2.925 2.925 0 0117 9c.767 0 1.467.3 2 .781A2.981 2.981 0 0121 9c1.395 0 2.578.982 2.906 2.281.368-.163.762-.281 1.188-.281 1.645 0 3 1.355 3 3v7.813a8.173 8.173 0 01-8.188 8.188h-1.719a8.299 8.299 0 01-5-1.688l-.031-.063-.063-.031-8.188-8.094v-.031c-1.154-1.154-1.154-3.034 0-4.188s3.034-1.154 4.188 0l.25.219.656.688V5c0-1.645 1.355-3 3-3zm0 2c-.555 0-1 .445-1 1v16.625l-4.313-4.313c-.446-.446-.929-.446-1.375 0s-.446.929 0 1.375l8.094 8c1.051.788 2.317 1.313 3.781 1.313h1.719c3.467 0 6.188-2.721 6.188-6.188v-7.813c0-.555-.445-1-1-1s-1 .445-1 1v2H22v-4c0-.555-.445-1-1-1s-1 .445-1 1v4h-2v-4c0-.555-.445-1-1-1s-1 .445-1 1v4h-2v-11c0-.555-.445-1-1-1z"}})])
          )
        }
      }
    